import { MaterialMajorCategory } from "../MaterialMajorCategory/MaterialMajorCategory.type";
import { MaterialSubCategory } from "../MaterialSubCategory/MaterialSubCategory.type";
import { ApiCallState } from "../Utils";
import { Store } from "../Store/Store.type";

export const MaterialActions = {
  FETCH_MATERIAL: "FETCH_MATERIAL",
  FETCH_MATERIAL_SUCCESS: "FETCH_MATERIAL_SUCCESS",
  FETCH_MATERIAL_ERROR: "FETCH_MATERIAL_ERROR",

  FETCH_MATERIAL_BALANCE: "FETCH_MATERIAL_BALANCE",
  FETCH_MATERIAL_BALANCE_SUCCESS: "FETCH_MATERIAL_BALANCE_SUCCESS",
  FETCH_MATERIAL_BALANCE_ERROR: "FETCH_MATERIAL_BALANCE_ERROR",
};

export type Material = {
  material_unit_prices: never[];
  id: any;
  item_category: string;
  sub_category: string;
  description: string;
  unit: string;
  code_prefix?: string;
  code: number;
  deprecation: number;
  material_sub_category?: MaterialSubCategory;
  material_major_category?: MaterialMajorCategory;
  item_code?: string;
  store_id: number;
  store?: Store;
  is_opened?: boolean;
  balance?: number;
  source_type?: 'Internal' | 'External';
  material_major_category_id?: number;
  material_sub_category_id?: number;
  type?: 'Material' | 'Service';
};

export type MaterialUnitPrice = {
  id: number;
  material_id: number;
  unit_price: number;
  quantity: number;
  good_received_item_id: number;
  date: string;
};

export type MaterialStateTypes = {
  fetchAll: ApiCallState<Material[]>;
  fetchAllBalance: ApiCallState<Material[]>;
};
